'use strict';

var React = require('react');
var bemReactClassname = require('bem-react-classname');
var ContainerMIcon = require('@alfalab/icons-glyph/ContainerMIcon');
var typography = require('@alfalab/core-components/typography');
var core_backgroundPlate_types = require('../../types.js');
require('./overlay.css');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var cn = bemReactClassname.createCn('overlay');
var Overlay = function (_a) {
    var visible = _a.visible, text = _a.text, isInner = _a.isInner, view = _a.view, error = _a.error;
    return (React__default.default.createElement("div", { className: cn({
            visible: visible,
            inner: isInner,
            primary: view === core_backgroundPlate_types.BackgroundPlateView.Dropzone,
            secondary: view === core_backgroundPlate_types.BackgroundPlateView.DropzoneSecondary,
            error: error,
        }) },
        React__default.default.createElement(ContainerMIcon.ContainerMIcon, null),
        React__default.default.createElement(typography.Typography.Text, { view: "primary-medium" }, text)));
};

exports.Overlay = Overlay;
